import { useEffect, useState, useRef } from 'react';
import api from '../api/axios';
import { getToken } from '../utils/auth';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import AdminMenu from '../components/admin/AdminMenu';
import Loader from '../components/Loader';

Modal.setAppElement('#root');

export default function Dashboard() {
  const [citas, setCitas] = useState([]);
  const [loadingCitas, setLoadingCitas] = useState(true);
  const [loadingRol, setLoadingRol] = useState(true);
  const [tokenInfo, setTokenInfo] = useState('');
  const [vista, setVista] = useState('proximas');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [rolUsuario, setRolUsuario] = useState('');
  const [perfilActivo, setPerfilActivo] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [paginaHistorial, setPaginaHistorial] = useState(1);
  const citasPorPagina = 15;

  // ⬇️ NUEVO: ajuste dinámico (fallback 12h)
  const [horasMinCancel, setHorasMinCancel] = useState(12);

  const navigate = useNavigate();
  const refCitas = useRef(null);

  // ⬇️ NUEVO: carga del ajuste horas_minimas_cancelacion
  useEffect(() => {
    const token = getToken();
    if (!token) return;

    // Opción A: endpoint que devuelve todos los ajustes como objeto
    api.get('/ajustes', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const valor = Number(res.data?.horas_minimas_cancelacion);
        if (!Number.isNaN(valor) && valor > 0) setHorasMinCancel(valor);
      })
      .catch(err => {
        console.error('❌ Error al cargar horas_minimas_cancelacion:', err);
        // mantenemos fallback
      });

    /* // Opción B: si tienes endpoint por clave
    api.get('/ajustes/horas_minimas_cancelacion', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const valor = Number(res.data?.valor);
        if (!Number.isNaN(valor) && valor > 0) setHorasMinCancel(valor);
      })
      .catch(err => console.error('❌ Error al cargar horas_minimas_cancelacion:', err));
    */
  }, []);

  const cargarCitas = () => {
    const token = getToken();
    if (!token) return navigate('/login');

    try {
      const decoded = jwtDecode(token);
      setTokenInfo(decoded || '');
    } catch (err) {
      console.error('❌ Token inválido:', err);
      navigate('/login');
    }

    api.get('/auth/verify', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => {
        return api.get('/citas/mis-citas', {
          headers: { Authorization: `Bearer ${token}` }
        });
      })
      .then(res => {
        setCitas(res.data.citas || []);
        setLoadingCitas(false);
      })
      .catch(err => {
        console.error(err);
        navigate('/login');
      });
  };

  const comprobarRol = async () => {
    const token = getToken();
    const telefonoGuardado = localStorage.getItem('telefono');

    if (!telefonoGuardado) {
      setLoadingRol(false);
      return;
    }

    try {
      const res = await api.post(
        '/auth/check-rol',
        { telefono: telefonoGuardado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRolUsuario(res.data.rol);
    } catch (err) {
      console.error('❌ Error al comprobar el rol:', err);
    } finally {
      setLoadingRol(false);
    }
  };

  useEffect(() => {
    cargarCitas();
    comprobarRol();
  }, []);

  const abrirModalCancelacion = (cita) => {
    setCitaSeleccionada(cita);
    setMostrarModal(true);
  };

  // ⬇️ MODIFICADO: usa horasMinCancel dinámico
  const sePuedeCancelar = (fecha, hora) => {
    const fechaHoraCita = new Date(`${fecha}T${hora}`);
    const ahora = new Date();
    const diferenciaHoras = (fechaHoraCita - ahora) / (1000 * 60 * 60);
    return diferenciaHoras >= horasMinCancel;
  };

  const confirmarCancelacion = async () => {
    const token = getToken();
    setCancelando(true);

    try {
      await api.post(`/citas/cancelar`, {
        citaId: citaSeleccionada.id,
        nombre: tokenInfo.nombre,
        apellidos: tokenInfo.apellidos,
        telefono: tokenInfo.telefono,
        email: tokenInfo.email,
        fecha: citaSeleccionada.fecha,
        hora_inicio: citaSeleccionada.hora_inicio,
        servicio: citaSeleccionada.Servicio
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Cita cancelada correctamente');
      cargarCitas();
    } catch (err) {
      console.error('❌ Error al cancelar:', err);
      toast.error('No se pudo cancelar la cita');
    } finally {
      setMostrarModal(false);
      setCitaSeleccionada(null);
      setCancelando(false);
    }
  };

  const ahora = new Date();
  const citasFiltradas = citas
    .filter(cita => {
      if (vista === 'proximas') {
        const fechaCita = new Date(`${cita.fecha}T${cita.hora_inicio}`);
        return fechaCita >= ahora && (
          cita.asistencia === null ||
          cita.asistencia === 'necesita_confirmacion' ||
          cita.asistencia === 'pendiente' ||
          cita.asistencia === 'pendiente_pagar'
        );
      } else {
        return (
          cita.asistencia === 'asistio' ||
          cita.asistencia === 'no_asistio' ||
          cita.asistencia === 1 ||
          cita.asistencia === 0 ||
          cita.asistencia === '1' ||
          cita.asistencia === '0'
        );
      }
    })
    .sort((a, b) => {
      const fechaA = new Date(`${a.fecha}T${a.hora_inicio}`);
      const fechaB = new Date(`${b.fecha}T${b.hora_inicio}`);
      return vista === 'proximas' ? fechaA - fechaB : fechaB - fechaA;
    });

  const citasPaginadas = vista === 'historial'
    ? citasFiltradas.slice((paginaHistorial - 1) * citasPorPagina, paginaHistorial * citasPorPagina)
    : citasFiltradas;

  if (loadingCitas || loadingRol) return <Loader />;

  return (
    <main className={rolUsuario === 'admin' ? 'admin-panel' : ''}>
      <div className={`grid-dashboard site-width ${rolUsuario !== 'admin' ? 'grid-usuario' : ''}`}>
        <div className="dashboard-header">
          <div className="texto-dashboard">
            <h1>¡Hola {tokenInfo.nombre}!</h1>
            <p>{rolUsuario === 'admin' ? 'Este es tu panel de administración.' : 'Gestiona tus citas y preferencias.'}</p>
          </div>
          <div className="botones-header-dashboard">
            <Link to="/reservar">
              <img src="/images/calendario.svg" alt="Icono" />
              <p>Nueva reserva</p>
            </Link>
          </div>
        </div>

        <div className="grid-panel">
          {rolUsuario === 'admin' ? (
            <AdminMenu />
          ) : (
            <div className='grid-citas' ref={refCitas}>
              <div className="tabs-citas">
                <button className={vista === 'proximas' ? 'activo' : ''} onClick={() => {
                  setVista('proximas');
                  setPaginaHistorial(1);
                }}>Próximas citas</button>
                <button className={vista === 'historial' ? 'activo' : ''} onClick={() => {
                  setVista('historial');
                  setPaginaHistorial(1);
                }}>Historial de citas</button>
              </div>

              {citasFiltradas.length === 0 ? (
                <p className='warning-msg'>
                  {vista === 'proximas' ? 'No tienes próximas citas reservadas.' : 'No hay citas en tu historial.'}
                </p>
              ) : (
                <>
                  {citasPaginadas.map((cita, index) => {
                    const cancelable = sePuedeCancelar(cita.fecha, cita.hora_inicio);
                    return (
                      <div className='item-citas' key={index}>
                        <p className={
                          cita.asistencia === 'pendiente_pagar' ||
                          cita.asistencia === 'pendiente' ||
                          cita.asistencia == null
                            ? 'por-asistir'
                            : cita.asistencia === 'necesita_confirmacion'
                              ? 'pendiente-confirmacion'
                              : cita.asistencia === 'no_asistio' || cita.asistencia === 0 || cita.asistencia === '0'
                                ? 'no-asistio'
                                : 'asistencia'
                        }>
                          {cita.asistencia === 'pendiente_pagar' ||
                          cita.asistencia === 'pendiente' ||
                          cita.asistencia == null ? (
                            <>Cita próxima confirmada</>
                          ) : cita.asistencia === 'necesita_confirmacion' ? (
                            <>
                              <b>[Pendiente de confirmación]</b><br />
                              Esta cita no ha sido confirmada todavía por el administrador, esto suele ocurrir cuando reservas dos veces en la misma semana.
                            </>
                          ) : cita.asistencia === 'no_asistio' || cita.asistencia === 0 || cita.asistencia === '0' ? (
                            'No asististe'
                          ) : (
                            'Asistencia confirmada'
                          )}
                        </p>

                        <div>
                          {cita.asistencia === 'pendiente_pagar' && (
                            <p className='pagar-cita-msg'>
                              <b>[IMPORTANTE]</b>
                              <br />
                              En esta próxima cita deberás abonar la mitad del servicio anterior por no haber asistido. Acciones reiteradas pueden llevar a un bloqueo de tu cuenta.
                            </p>
                          )}
                          <h4>{cita.Servicio?.nombre || 'Servicio no definido'}</h4>
                          <p className='fecha-cita'>
                            {format(new Date(`${cita.fecha}T${cita.hora_inicio}`), "eeee, d 'de' MMMM", { locale: es })}
                          </p>
                        </div>

                        <div className="cita-info">
                          <div className='hora-inicio'>
                            <img src="/images/tiempo.svg" alt="Icono" />
                            <p>{format(new Date(`1970-01-01T${cita.hora_inicio}`), 'HH:mm aaaa')}</p>
                          </div>
                          <div className='precio-cita'>
                            <img src="/images/tijeras.svg" alt="Icono" />
                            <p>{cita.precio_cita ?? cita.Servicio?.precio}€</p>
                          </div>
                        </div>

                        {vista === 'proximas' && (
                          <button
                            className={`boton-cancelar ${!cancelable ? 'cancelacion-no-disponible' : ''}`}
                            onClick={() => cancelable && abrirModalCancelacion(cita)}
                            disabled={!cancelable}
                            title={!cancelable ? `La cancelación requiere al menos ${horasMinCancel} h de antelación` : 'Cancelar cita'}
                          >
                            {cancelable ? 'Cancelar' : `Cancelación no disponible`}
                          </button>
                        )}
                      </div>
                    );
                  })}

                  {vista === 'historial' && citasFiltradas.length > citasPorPagina && (
                    <div className="paginacion-citas">
                      {Array.from({ length: Math.ceil(citasFiltradas.length / citasPorPagina) }).map((_, i) => (
                        <button
                          key={i}
                          className={paginaHistorial === i + 1 ? 'activo' : ''}
                          onClick={() => {
                            setPaginaHistorial(i + 1);
                            if (refCitas.current) {
                              window.scrollTo({
                                top: refCitas.current.getBoundingClientRect().top + window.scrollY - 100,
                                behavior: 'auto'
                              });
                            }
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          <div
            className={`perfil ${perfilActivo ? 'perfil-activo' : ''}`}
            onClick={() => setPerfilActivo(prev => !prev)}
          >
            <div className="info-header-perfil">
              <p>Información de tu perfil</p>
              <p>Estos son tus datos asociados a tu cuenta y reservas.</p>
            </div>
            <div className="datos-perfil">
              <div className="bloque-dato"><p>Nombre</p><p>{tokenInfo.nombre}</p></div>
              <div className="bloque-dato"><p>Apellidos</p><p>{tokenInfo.apellidos}</p></div>
              <div className="bloque-dato">
                <p>Email</p>
                {tokenInfo.email
                  ? <p>{tokenInfo.email}</p>
                  : <p className='por-definir'>No se ha definido, por lo tanto, no pueden llegarte notificaciones.</p>}
              </div>
              <div className="bloque-dato">
                <p>Teléfono</p>
                <PhoneInput
                  country={'es'}
                  value={'+' + tokenInfo.telefono}
                  disabled
                  inputStyle={{ backgroundColor: 'transparent', border: 'none', paddingLeft: '30px', color: '#000' }}
                  buttonStyle={{ border: 'none', backgroundColor: 'transparent' }}
                />
              </div>
              <Link to="/editar-perfil" className='boton-editar-perfil'>Editar perfil</Link>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={mostrarModal}
        onRequestClose={() => setMostrarModal(false)}
        contentLabel="Confirmar cancelación"
        className="modal-cancelacion"
        overlayClassName="modal-overlay"
      >
        <h2>¿Cancelar cita?</h2>
        <p>¿Estás seguro de que deseas cancelar tu cita?</p>
        <div className="botones-modal">
          <button onClick={confirmarCancelacion} disabled={cancelando}>
            {cancelando ? 'Cancelando...' : 'Sí, cancelar'}
          </button>
          <button onClick={() => setMostrarModal(false)}>No</button>
        </div>
      </Modal>

      <ToastContainer position="bottom-right" />
    </main>
  );
}
